// src/components/Table/TableRow.tsx

import React from 'react';
import { BodyRow } from './styles';

interface TableRowProps {
    children: React.ReactNode;
    clickable?: boolean;
    onClick?: () => void;
}

export const TableRow: React.FC<TableRowProps> = ({
    children,
    clickable = false,
    onClick
}) => {
    return (
        <BodyRow $clickable={clickable} onClick={onClick}>
            {children}
        </BodyRow>
    );
};